import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { UserActionsList } from './UserActionsList/UserActionsList';
import { UserActionsShow } from './UserActionsShow/UserActionsShow';

export const userActionsResource: ResourceProps = {
  name: Resources.UserActions,
  create: <></>,
  edit: <></>,
  list: UserActionsList,
  show: UserActionsShow,
};
